import './wp-cart.scss';

import Vue, { VueConstructor } from 'vue';
import { Prop, DefaultProps } from "vue/types/options";
import WpBaseComponent from './../../wp-base-component';
import Component, { mixins } from 'vue-class-component';
import {
    Cart, CartItem, IMetricsService, MetricsSymbols, BaseSystemLocalizationDictionary,
    INotificationService, NotificationSymbols, NotificationEventArgs, NotificationTypes
} from 'web-platform-core-ui';
import { formatPrice } from 'web-platform-core-ui/src/Utility/format';
import { MetricsEvents } from '../../metrics-events-symbols';

export const wpCartProps = Vue.extend({
    props: {
        Cart: Object as Prop<Cart>,
        Type: Number
    }
})

@Component({
    template: require("./wp-cart.html")
})
export default class WpCart extends mixins<WpBaseComponent<WpCartDictionary>, DefaultProps, VueConstructor>(WpBaseComponent, wpCartProps, Vue) {
    // Enable notifications/sygnals to send to other parts of the program
    protected _notificationService!: INotificationService;
    UILoading = false;

    _formatPrice = formatPrice;
    _metricsService!: IMetricsService;

    CartModal: boolean = false;

    async created() {
        this._metricsService = this.GlobalService.Get<IMetricsService>(MetricsSymbols.MetricsService);
        // Get notification service up and ready
        this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);
    }

    async mounted() {
        this.$parent.$on('ExternalCart', this.OpenCart);
    }

    get Items(): Array<CartItem> {
        this._notificationService.SendSystemNotification("CartContent", this.Cart.Items);
        return this.Cart.Items;
    }

    OpenCart(): void {
        this.CartModal = true;
        this._metricsService.RegistrateEvent(MetricsEvents.WidgetOpenCart);
    }

    Pay(): void {
        this.CartModal = false;
        this._metricsService.RegistrateEvent(MetricsEvents.IncartToPurchase);
        this.$emit("CartReservation");
    }

    RemoveItem(itemId: string): void {
        let cartItem = this.Cart.Items.find((x: { TempId: string; }) => x.TempId == itemId);

        this.Cart.RemoveItem(itemId);
        this.$emit('CartHaveItems', this.Cart.Items.length > 0);

        this._metricsService.RegistrateEvent(MetricsEvents.IncartRemove, cartItem?.MetricsId);
    }

    async ClearCart(): Promise<void> {
        this.UILoading = true;
        // This method clears cart's content
        await this.Cart.Clear();
        this._metricsService.RegistrateEvent(MetricsEvents.IncartCancel);
        this.$emit('CartHaveItems', this.Cart.Items.length > 0);
        // Close cart after clearing it (Optional)
        this.CloseCart();
        this.UILoading = false;
    };

    CloseCart() {
        this.CartModal = false;
        this._metricsService.RegistrateEvent(MetricsEvents.WidgeCloseCart);
    }
}

export class WpCartDictionary extends BaseSystemLocalizationDictionary {
    GenericCart: string = '';
    GenericClearCart: string = '';
    GenericTotal: string = '';
    GenericCheckout: string = '';
}